const NfcCard = ({ className = "", compact = false }) => (
  <div
    data-testid="nfc-card"
    className={`relative aspect-[1.586/1] w-full overflow-hidden rounded-xl border border-[#C19D60]/35 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.9)] ${className}`}
    style={{
      backgroundImage: "linear-gradient(rgba(5,5,5,0.55), rgba(5,5,5,0.75)), url('/assets/marble.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <div className="absolute inset-[7px] rounded-lg border border-[#C19D60]/20" aria-hidden="true" />
    <svg className="absolute inset-0 h-full w-full opacity-60" viewBox="0 0 400 252" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="veinGold" x1="0" y1="0" x2="400" y2="252" gradientUnits="userSpaceOnUse">
          <stop stopColor="#8a6d3b" />
          <stop offset="0.5" stopColor="#E5CAA4" />
          <stop offset="1" stopColor="#8a6d3b" />
        </linearGradient>
      </defs>
      <path d="M-20 200 C 90 150, 160 230, 260 160 S 400 120, 430 150" stroke="url(#veinGold)" strokeWidth="1" opacity="0.5" />
      <path d="M-30 60 C 80 110, 200 40, 300 90 S 410 60, 440 80" stroke="url(#veinGold)" strokeWidth="0.7" opacity="0.35" />
      <path d="M60 260 C 120 190, 240 230, 330 180" stroke="url(#veinGold)" strokeWidth="0.6" opacity="0.3" />
    </svg>
    <div className="pointer-events-none absolute inset-0 overflow-hidden rounded-xl" aria-hidden="true">
      <div className="absolute inset-y-0 w-1/3 bg-gradient-to-r from-transparent via-white/[0.07] to-transparent" style={{ animation: "shimmer 6s ease-in-out infinite" }} />
    </div>

    <div className="relative flex h-full flex-col justify-between p-[6%]">
      <div className="flex items-start">
        <img src="/assets/recensio-logo.png" alt="Recensio" className={compact ? "h-6 w-auto" : "h-9 w-auto"} />
      </div>
      <div className="flex flex-1 items-center justify-center">
        <p data-testid="nfc-card-menu-label" className={`font-display gold-text italic ${compact ? "text-2xl" : "text-4xl"}`} style={{ letterSpacing: "0.16em" }}>
          Menu
        </p>
      </div>
      <div className="flex items-end justify-between">
        <p className={`font-light uppercase tracking-[0.4em] text-[#E5CAA4]/80 ${compact ? "text-[7px]" : "text-[9px]"}`}>
          Tap to connect
        </p>
        <p className={`font-display italic text-[#F8F5F0]/70 ${compact ? "text-xs" : "text-base"}`}>premium</p>
      </div>
    </div>
  </div>
);

export default NfcCard;
